import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import moment from 'moment'

const LocationManage = (props) => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(false)
    const settingCustomContext = useContext(SettingCustomContext)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    // const {
    //     searchTableAction,
    //     responseStatus: responseStatusSetting,
    //     clearResponse: clearResponseCommuncation,
    // } = settingCustomContext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        name: Yup.string().required('Required!'),
        isoCode: Yup.string().required('Required!'),
        IsoAlpha3Code: Yup.string().required('Required!'),
        IsoNumericCode: Yup.number().required('Required!'),
        CigarWatchCountry: Yup.number().required('Required!'),
        BuyerWatchCountry: Yup.number().required('Required!'),
        SellerWatchCountry: Yup.number().required('Required!'),
        TobaccoAge: Yup.number().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            name: '',
            isoCode: '',
            IsoAlpha3Code: '',
            IsoNumericCode: 0,
            CigarWatchCountry: 0,
            BuyerWatchCountry: 0,
            SellerWatchCountry: 0,
            TobaccoAge: 0,
            Territory_EU: 0,
            Payment_Type: '',
            Allow_Bids: 0,
            Allow_Listings: 0,
            phonecode: '',
            currency: '',
            global_publisher: true,
            updateDataCountry: true,
            // where: 'factory_code',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.table = 'data_country'
            values.updateDataCountry = true
            values.global_publisher = true
            // values.uniqueValue = values.factory_code
            if (!isLoading) {
                searchTableAction(values, false, 'country_create')
                setIsLoading(true)
            }
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'country_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                props.setLoading(true)
                formik.resetForm()
                setIsLoading(false)
            } else if (responseStatusSetting.from === 'country_create') {
                setIsLoading(false)
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (data.status != 'new') {
            formik.setFieldValue('id', data.id)
            const template =
                props?.record?.find((cat) => cat.id === data.id) || {}

            formik.setValues({
                ...formik.values,
                ...template,
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,

            name: '',
            isoCode: '',
            IsoAlpha3Code: '',
            IsoNumericCode: 0,
            CigarWatchCountry: 0,
            BuyerWatchCountry: 0,
            SellerWatchCountry: 0,
            TobaccoAge: 0,
            Territory_EU: 0,
            Payment_Type: '',
            Allow_Bids: 0,
            Allow_Listings: 0,
            phonecode: '',
            currency: '',
            // where: 'factory_code',
        })
    }

    const details = {
        formik: formik,
        data: [
            {
                label: 'Country Name',
                placeholder: 'Enter Country Name',
                type: '',
                required: true,
                class: 'col-6',
                name: 'name',
            },
            {
                label: 'Enter isoCode ',
                placeholder: 'Enter isoCode ',
                type: '',
                required: true,
                class: 'col-6',
                name: 'isoCode',
            },
            {
                label: 'Enter IsoAlpha3Code',
                placeholder: 'Enter IsoAlpha3Code',
                type: '',
                required: true,
                class: 'col-6',
                name: 'IsoAlpha3Code',
            },
            {
                label: 'Enter IsoNumericCode',
                placeholder: 'Enter IsoNumericCode',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'IsoNumericCode',
            },
            {
                label: 'Enter CigarWatchCountry',
                placeholder: 'Enter CigarWatchCountry',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'CigarWatchCountry',
            },
            {
                label: 'Enter BuyerWatchCountry',
                placeholder: 'Enter BuyerWatchCountry',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'BuyerWatchCountry',
            },
            {
                label: 'Enter SellerWatchCountry',
                placeholder: 'Enter SellerWatchCountry',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'SellerWatchCountry',
            },
            {
                label: 'Enter TobaccoAge',
                placeholder: 'Enter TobaccoAge',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'TobaccoAge',
            },
            {
                label: 'Enter Territory EU',
                placeholder: 'Enter Territory EU',
                type: 'select',
                options: [
                    {
                        show: 'Yes',
                        value: 1,
                    },
                    {
                        show: 'No',
                        value: 0,
                    },
                ],
                required: true,
                class: 'col-6',
                name: 'Territory_EU',
            },
            {
                label: 'Allow Bids',
                placeholder: 'Allow Bids',
                type: 'select',
                options: [
                    {
                        show: 'Yes',
                        value: 1,
                    },
                    {
                        show: 'No',
                        value: 0,
                    },
                ],
                required: true,
                class: 'col-6',
                name: 'Allow_Bids',
                // onChange: (e) => {
                //     console.log(
                //         'dddddddddddddddddddd',
                //         e.target.value,
                //         typeof e.target.value
                //     )
                // },
            },
            {
                label: 'Enter Allow Listings',
                placeholder: 'Enter Allow Listings',
                type: 'select',
                options: [
                    {
                        show: 'Yes',
                        value: 1,
                    },
                    {
                        show: 'No',
                        value: 0,
                    },
                ],
                required: true,
                class: 'col-6',
                name: 'Allow_Listings',
            },
        ],
    }

    const submitFunction = () => {
        formik.handleSubmit()
        //toggleFullScreenPopup(false)
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Country'
                    : data.status === 'edit'
                    ? 'Edit Country'
                    : 'Edit Country'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    {/* <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        > */}
                    <div className="row">{mapData(details)}</div>

                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default LocationManage
